import IframeActivity from "./IframeActivity";

export default function BiasTranslator() {
    return (
        <IframeActivity
            src="/activities/bias-translator/index.html"
            title="Bias Translator"
        />
    );
}